import type { PortalContextResponse } from '@lipaflow/portal-core'

/**
 * School-flavoured defaults, used while `/portal/context` is loading or
 * unavailable. These lived in `packages/portal-core` until ADR-0004 — Tier 1
 * held both verticals' vocabulary because there was nowhere else to put it.
 */
export const SCHOOL_DEFAULT_CONTEXT: PortalContextResponse = {
  tenant_name: '',
  vertical_code: 'school',
  labels: {
    payer: 'Parent',
    entity: 'Student',
    obligation: 'Fee',
    period: 'Term',
    entity_reference: 'Admission Number',
  },
  features: {},
}
